import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

export interface ReportsSummary {
	completedLast7Days: number;
	completedLast30Days: number;
	inProgress: number;
	compliantRate: number;
	activeStores: number;
}

const fetchReportsSummary = async (): Promise<ReportsSummary> => {
	const response = await cmsClient.get("/observations/reports/summary/");
	const data = response.data;

	return {
		completedLast7Days: data.completed_last_7_days,
		completedLast30Days: data.completed_last_30_days,
		inProgress: data.in_progress,
		compliantRate: data.compliant_rate,
		activeStores: data.active_stores
	};
};

interface ReportsSummaryOptions {
	enabled?: boolean;
}

const useReportsSummary = ({ enabled = true }: ReportsSummaryOptions = {}) => {
	return useQuery(["reports-summary"], fetchReportsSummary, {
		retry: false,
		enabled
	});
};

export default useReportsSummary;
